/** API route map: URLS.Controller.CareerPage */
export const CareerPage = {
      Name: 'CareerPage/',
      GetCareerPage: 'get-career-page',
      GetCareerPageDisplayImages: 'career-page-display-images',
      GetAllPublishedJobs: 'publish-jobs',
      GetPublishedJobInfo: 'get-job-info',
      GetPublishedJobBillingInfo: 'get-job-billing-info',
      ApplyJob: 'apply',
      CheckExistingEmail: 'check-existing-email',
      ReferJob: 'refer',
      GetCareerPageByCompanyId: 'get-career-page-by-company-id',
};
